import { useState } from "react";
import { IButtonGroup, IColumn } from "../../../../Interfaces/filter";
import { useBoolean } from "@fluentui/react-hooks";
import { initialUbicacionDTO, IUbicacionDTO } from "../../../../Interfaces/auxiliar/IUbicacion";
import { DetailsListLayoutMode, ICommandBarItemProps, Icon, TooltipHost } from "@fluentui/react";
import themeBase from "../../../../utils/theme/themeBase";
import { UseUbicacion } from "./UseUbicacion";
import { HeadingBar } from "../../../../components/generic/HeadingBar";
import { TableComponent } from "../../../../components/Table/TableComponent";
import { PanelEditarUbicacion } from "./crud/ubicacionEditar/PanelUbicaciónEditar";
import { PanelUbicacionCrear } from "./crud/ubicacionCrear/PanelUbicacionCrear";
import { PanelUbicacionEliminar } from "./crud/ubicacionEliminar/PanelUbicacionEliminar";
import { Button } from "@fluentui/react-components";
import { EditRegular, DeleteRegular } from "@fluentui/react-icons";
import { useIconsCatalogo } from "../../../../components/iconCatalog/common.useIconsCatalogo";
import { CommonHeaderComponent } from "../../../../components/generic/common.Header";
import IconHelper from "../../../../utils/helpers/iconHelper";
import { CabeceraTable } from "../../../../components/Table/CabeceraTable";
import { TableBaseComponent } from "../../../../components/Table/TableBaseComponent";
import { PanelUbicacionSync } from "./crud/ubicacionSync/PanelUbicacionSync";

const iconDetalleStyle: React.CSSProperties | undefined = {
    color: "#0078d4",
};

interface UbicacionProps {
    nivel: number;
    descripcion?: string;
    comboDescripcion?: string
    comboNivel?: number
}

const Ubicacion = ({ nivel, descripcion = "", comboDescripcion = "", comboNivel }: UbicacionProps) => {
    const [isOPenPanelCrear, { setTrue: openPanelCrear, setFalse: closePanelCrear }] = useBoolean(false);
    const [isOpenEliminar, { setTrue: openPanelEliminar, setFalse: closePanelEliminar }] = useBoolean(false);
    const [item, setItem] = useState<IUbicacionDTO>(initialUbicacionDTO)
    const [isOpenEditar, { setTrue: openPanelEditar, setFalse: closePanelEditar }] = useBoolean(false);
    const [isOpenSYNC, { setTrue: openPanelSYNC, setFalse: closePanelSYNC }] = useBoolean(false);
    const { items, filter, setFilter, loading, pagination, handleResetUpdate, onChangeSearch, onChangeTake, _onkeyUpSearchTable } = UseUbicacion({ nivel });

    const nivelNombres: Record<number, string> = {
        1: "Tajo",
        2: "Región",
        3: "Ubicación",
    };

    const nombreNivel = nivelNombres[nivel ?? 1] || "Sin Nivel";

    const buttonLeft: ICommandBarItemProps[] = [
        {
            ...IconHelper.ICON_RELOAD,
            text: "Actualizar",
            onClick: () => {
                handleResetUpdate()
            },
        },
        {
            ...IconHelper.ICON_RELOAD2,
            text: "Sincronizar",
            onClick: () => {
              openPanelSYNC()
            },
          }
    ];

    function renderOpciones(item: IUbicacionDTO) {
        return (
            <>
                <TooltipHost content={"Editar"}>
                    <Icon
                        iconName="Edit"
                        className={themeBase.classNamesIcon.iconFont}
                        style={{ cursor: "pointer", color: "#0078d3" }}
                        onClick={() => {
                            setItem(item)
                            openPanelEditar()
                        }}
                    />
                </TooltipHost>
                <TooltipHost content={"Quitar"}>
                    <Icon
                        iconName="Delete"
                        className={themeBase.classNamesIcon.iconFont}
                        style={{ cursor: "pointer", color: "#0078d3" }}
                        onClick={() => {
                            setItem(item)
                            openPanelEliminar()
                        }}
                    />
                </TooltipHost>
            </>
        );
    }

    const _columns = [
        {
            key: "numeracion",
            name: "N°",
            fieldName: "numeracion",
            minWidth: 30,
            maxWidth: 50,
            onRender: (item, index) => {
                const startIndex = (filter.skip ?? 0);
                return <>{startIndex + (index ?? 0) + 1}</>;
            }
        },
        {
            key: "modelo",
            name: "Nombre",
            fieldName: "nombre",
            minWidth: 100,
            maxWidth: 300,
        },
        {
            key: "nivel",
            name: "Nivel",
            fieldName: "nivel",
            minWidth: 100,
            maxWidth: 100
        },
        ...(nivel === 2 || nivel === 3 ? [{
            key: "Parent",
            name: nivel === 2 ? "Tajo" : "Región",
            fieldName: "parent",
            minWidth: 300,
            maxWidth: 300,
        }] : []),
        {
            key: "opciones",
            name: "Opciones",
            minWidth: 2,
            maxWidth: 2,
            fieldName: "opciones",
            onRender: (item: IUbicacionDTO) => renderOpciones(item)
        },
    ]
    return (
        <>
            <CabeceraTable
                Titulo={nombreNivel}
                SubTitulo={`Gestión de ${descripcion}`}
                placeholder="Buscar Por Nombre"
                componentRef={onChangeSearch}
                onKeyUp={_onkeyUpSearchTable}
            />
            <TableBaseComponent
                leftBar={buttonLeft}
                rigthBar={[]}
                data={items}
                column={_columns}
                isLoading={loading}
                getPageSize={onChangeTake}
                pagination={pagination}
                layout={DetailsListLayoutMode.justified}
                tableSiza
            />

            <PanelEditarUbicacion
                item={item}
                isOpen={isOpenEditar}
                onDismiss={closePanelEditar}
                reload={handleResetUpdate} />

            <PanelUbicacionCrear
                isOpen={isOPenPanelCrear}
                onDismiss={closePanelCrear}
                filtro={filter}
                setFiltro={setFilter}
                reload={handleResetUpdate}
                comboDescripcion={comboDescripcion}
                comboNivel={comboNivel}
                nivel={nivel}
            />
            <PanelUbicacionSync nivel={nivel} isOpen={isOpenSYNC} onDismiss={closePanelSYNC} reload={handleResetUpdate}/>

            {isOpenEliminar && <PanelUbicacionEliminar
                item={item}
                isOpen={isOpenEliminar}
                onDismiss={closePanelEliminar}
                reload={handleResetUpdate}
            />}

        </>
    )
}

export { Ubicacion }